import { request } from '../fetch';

export async function sendReforcoOperation(operation, storageKey) {
  // Keep the original request across timeouts, modal closure and page reloads.
  const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
  const pending = saved || operation;
  localStorage.setItem(storageKey, JSON.stringify(pending));
  try {
    const result = await request(pending.url, { method: 'POST', body: JSON.stringify(pending.body) });
    localStorage.removeItem(storageKey);
    return result;
  } catch (error) {
    // A validation rejection happens before any credit. Unknown outcomes keep the key.
    if (error.status === 400) localStorage.removeItem(storageKey);
    throw error;
  }
}
